/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Notes_PlaceholderInputs */

const en_site_notes_placeholder = /** @type {(inputs: Site_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. a version for Indonesian small businesses, QRIS payments, simpler than the original`)
};

const id_site_notes_placeholder = /** @type {(inputs: Site_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. versi untuk UMKM Indonesia, bayar pakai QRIS, lebih sederhana dari aslinya`)
};

/**
* | output |
* | --- |
* | "e.g. a version for Indonesian small businesses, QRIS payments, simpler than the original" |
*
* @param {Site_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_notes_placeholder = /** @type {((inputs?: Site_Notes_PlaceholderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Notes_PlaceholderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_notes_placeholder(inputs)
	return en_site_notes_placeholder(inputs)
});